import { useCallback, useEffect, useState } from "react";
import { API } from "../auth/api";

export function useConnections() {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await API.get("/connections");
      setConnections(Array.isArray(data) ? data : []);
    } catch (_e) {
      setConnections([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const addConnection = useCallback(async (contactA, contactB, opts = {}) => {
    const { data } = await API.post("/connections", {
      contact_a: contactA,
      contact_b: contactB,
      relation: opts.relation || "linked",
      note: opts.note || "",
    });
    setConnections((prev) => {
      if (prev.some((c) => c.id === data.id)) return prev;
      return [...prev, data];
    });
    return data;
  }, []);

  const removeConnection = useCallback(async (id) => {
    await API.delete(`/connections/${id}`);
    setConnections((prev) => prev.filter((c) => c.id !== id));
  }, []);

  const completeConnection = useCallback(async (id) => {
    const { data } = await API.post(`/connections/${id}/complete`);
    setConnections((prev) => prev.map((c) => (c.id === id ? data : c)));
    return data;
  }, []);

  const uncompleteConnection = useCallback(async (id) => {
    const { data } = await API.delete(`/connections/${id}/complete`);
    setConnections((prev) => prev.map((c) => (c.id === id ? data : c)));
    return data;
  }, []);

  return {
    connections,
    loading,
    addConnection,
    removeConnection,
    completeConnection,
    uncompleteConnection,
    reload: load,
  };
}
